import Pagination from "./Pagination";
import GetIcon from "../../../utils/Icon";
import Filter from "./Filter";
import Sort from "./Sort";
import Loadercomp from "../Loadercomp";
import Table from "./Table";
import RolesandPermission from "../RolesandPermission";

const ListLayout = ({
  permissionname='',
  title,
  titleClass,
  holeClass,
  onFilterChange,
  filterComponents = [],
  tableHeaders,
  tabledata = [],
  actionButtons = [],
  setCurrentPage = 0,
  pageSize = 0,
  totalrecords = 0,
  setPageSize = 0,
  Buttons = [],
  isLoading,
  onSort = () => { },
  sortKey = null,
}) => {
  return (
    <>
      {isLoading ? (
        <div>
          <Loadercomp size={100} />
        </div>
      ) : (
        <div className="w-full  mx-auto py-3">
          <div
            className={`${
              holeClass ? holeClass : "py-4 bg-white rounded-lg shadow"
            }`}
          >
            {/* Header Section */}
            <div className="flex justify-between items-center mb-6 px-3">
              <h2
                className={`${
                  titleClass ? titleClass : "text-lg font-bold text-lightdark"
                }`}
              >
                {title}
              </h2>
              <RolesandPermission modulename={permissionname} type="create" >
              <div className="flex space-x-4">
                {Buttons.map((btn, index) => (
                                // <RolesandPermission modulename={permissionname} type="">
                  <button
                    className={btn.design}
                    key={index}
                    onClick={btn.onClick}
                  >
                    {btn.icon && <GetIcon iconName={btn.icon} size={17} />}
                    {btn.title}
                  </button>
                  // </RolesandPermission>
                ))}
              </div>
              </RolesandPermission>
            </div>
            <div className=" mb-1 px-3">
              <Filter
                filters={filterComponents}
                onFilterChange={onFilterChange}
              />
            </div>
            <Table
              tableHeaders={tableHeaders}
              actionButtons={actionButtons}
              tabledata={tabledata}
              sortKey={sortKey}
              onSort={onSort}
              tableClass={"px-4"}
            />

            <div className="">
              <div
                className="flex mt-1 px-3"
                style={{ justifyContent: "space-between" }}
              >
                {pageSize != 0 ? <Sort
                    setPageSize={setPageSize}
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                /> : ''}
                {pageSize != 0 ? <Pagination
                    setCurrentPage={setCurrentPage}
                    data={tabledata}
                    pageSize={pageSize}
                    totalrecords={totalrecords}
                /> : ''}

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListLayout;
